export function historySlider() {
    $(".no-touch .our-history .slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $(".our-history .common-slider-controls .prev-arrow"),
        nextArrow: $(".our-history .common-slider-controls .next-arrow"),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    variableWidth: true,
                }
            }
        ],
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/history-slider.js